import * as React from "react";

const QuizModal = () => (
  <div className="gen-modal hidden" id="openQuestionContainer">
    <div className="gen-modal-panel quiz-modal--container">
      <div id="quizModal"></div>
    </div>
  </div>
);

export default React.memo(QuizModal);
